export const UserEditSceneTranslation = {
  fi: {
    UserEditScene: {
      title: 'Muokkaa käyttäjää',
    },
  },
};
